export const paginationCountList: number[] = [10, 25, 50, 100, 500, 1000]
